module.exports = __webpack_public_path__ + "img/payment.3d33d119.svg";